import {HttpMethod, Resource} from "./contract/source";

// magic base values that are used to calculate absolute dimensions
export const GUTTER_SIZE = 45;
export const CONTENT_BASE_WIDTH = 240;
export const COLUMN_COUNT = 3;
export const PAGE_SIZE = 12;
export const CONTENT_BASE = COLUMN_COUNT * 1.125;
export const SMALL_ARTICLE_MIN_HEIGHT = 138;

const FORM_ROW_PADDING = `${GUTTER_SIZE / 2}px`;
const CONTENT_MAX_WIDTH = ((CONTENT_BASE - 0.75) * CONTENT_BASE_WIDTH) + (CONTENT_BASE - 0.75) * GUTTER_SIZE;
const FEATURED_IMAGE_WIDTH = (CONTENT_BASE * CONTENT_BASE_WIDTH) + (CONTENT_BASE - 0.25) * GUTTER_SIZE;
const SMALL_FEATURED_IMAGE_WIDTH = ((CONTENT_BASE - 1) * CONTENT_BASE_WIDTH) + (CONTENT_BASE - 2) * GUTTER_SIZE;

export const LAYOUT_CONSTANTS = {
  COLUMN_COUNT,
  CONTENT_BASE,
  CONTENT_BASE_WIDTH,
  CONTENT_MAX_WIDTH,
  GUTTER_SIZE,
  FORM_ROW_PADDING,
  FEATURED_IMAGE_WIDTH,
  SMALL_FEATURED_IMAGE_WIDTH,
}

const SKELETON_LOADER_BG = '#f7f7f7';
const SKELETON_LOADER_FG = '#d7d7d7';

export const SKELETON_LOADER = {
  SKELETON_LOADER_BG,
  SKELETON_LOADER_FG
}

export const RESOURCE: {[key: string]: Resource} = {
  block: [HttpMethod.GET, '/news/content'],
  article: [HttpMethod.GET, '/news/article'],
  articles: [HttpMethod.GET, '/news/article/list'],
  topic: [HttpMethod.GET, '/news/topic'],
  topics: [HttpMethod.GET, '/news/topic/list'],
  lead: [HttpMethod.POST, '/news/lead'],
}

export const LEAD_FORM: {[key: string]: [string, string]} = {
  full_name: ['text', 'Vul je naam in'],
  contact: ['text', 'Vul je e-mailadres of telefoonnummer in'],
  contact_email: ['text', 'Vul je e-mailadres in'],
  message: ['textarea', 'Stel ons je vraag'],
};

export const CONNECTION_ERROR = 'Oeps! Er lijkt iets mis te gaan. Controleer de verbinding en probeer het opnieuw.'
